import { Component, input } from '@angular/core';

import { WalletCard } from '@kr/models';
import { CurrencyBalanceFormatPipe } from '@kr/pipes';

@Component({
  selector: 'kr-wallet-item',
  imports: [CurrencyBalanceFormatPipe],
  templateUrl: './wallet-item.component.html',
  styleUrl: './wallet-item.component.scss',
})
export class WalletItemComponent {
  wallet = input<WalletCard>();
}
